import { api_gateway } from '../../conexoes/api'
import { requestResolver } from '../../utils/requestResolver'

export const OrdersService = {
  postOrder: (body) => {
    return requestResolver(
      api_gateway.post(`/api/v2/whitechip/iccids/order`, body)
    )
  },
  getCarriersOrder: () => {
    return requestResolver(
      api_gateway.get(`/api/v2/whitechip/iccids/order/carriers`)
    )
  },
  getPlansOrder: (CdOperadora) => {
    return requestResolver(
      api_gateway.get(`/api/v2/whitechip/iccids/order/plan`, {
        params: { CdOperadora }
      })
    )
  },
  getSimcardsTypeOrder: (CdOperadora) => {
    return requestResolver(
      api_gateway.get(`/api/v2/whitechip/iccids/order/simcardType`, {
        params: { CdOperadora }
      })
    )
  },
  getAddress: (cdCliente) => {
    return requestResolver(
      api_gateway.get(`/m1/consultar/cliente_endereco_entrega`, {
        params: { cd_pav_cliente: cdCliente }
      })
    )
  },
  getUf: () => {
    return requestResolver(api_gateway.get(`/m1/consultar/uf`))
  },
  getCep: (cep) => {
    return requestResolver(
      api_gateway.get(`/m1/consultar/cep`, {
        params: { cep }
      })
    )
  },
  getCourierTracking: (orderID) => {
    return requestResolver(
      api_gateway.get(`/api/v2/correios/trackObject/${orderID}`)
    )
  }
}
